import apiClient from "./BaseService";
import { URL } from "../config";

// const _getRoles = async () => apiClient.get(URL.GET_USER_ROLES);

// 0 = "Don't send all groups", 1 = "Send all groups"
const _getRoles = async (all: number) =>
  apiClient.get(URL.GET_USER_ROLES + (`?all_groups=${all}`));

const _addRole = async (name: string, description: string) => {
  const data = { name, description };
  return apiClient.post(URL.ADD_USER_ROLE, data);
};

const _editRole = async (id: any, name: string, description: string) => {
  const data = { name , description };
  return apiClient.patch(`${URL.ADD_USER_ROLE}${id}/`, data);
};

const _getAllPermissions = async () => apiClient.get(URL.GET_ALL_PERMISSIONS);

const _getAllSections = async () => apiClient.get(URL.GET_ALL_SECTIONS);

const _deleteGroup = async (id: any) =>
  apiClient.delete(`${URL.GET_USER_ROLES}${id}`);

const _editGroupPermissions = async (data: any) =>
  apiClient.post(URL.EDIT_GROUPS, data);

const _saveTabPermission = async (menuId:any, data: any) => 
  apiClient.post(`${URL.SAVE_TAB_PERMISSION}${menuId}/set_tab_permission/`, data);

export const RoleService = {
  _getRoles,
  _addRole,
  _getAllPermissions,
  _getAllSections,
  _editRole,
  _editGroupPermissions,
  _deleteGroup,
  _saveTabPermission,
};
